<template>
    <span>
        <a class='nav-month' href="#" @click.prevent="planningPreviousMonth"><i class="fas fa-chevron-left"></i></a>
        <a class='nav-month' href="#" @click.prevent="planningNextMonth"><i class="fas fa-chevron-right"></i></a>
        <Button @click.prevent="planningCurrentMonth" :empty="true">
            <template>
                {{ Translations.sections.planning.actions.currentMonth}}
            </template>
        </Button>
    </span>
</template>

<script>
    import store from '@/store/index.js'
    import Translations from '@/store/translations';
import { mapState, mapActions } from 'vuex';

    export default {
        name: "PlanningSectionActions",
        store,
        components: {
        },
        computed: {
            Translations: () => Translations,
            ...mapState(["PlanningMonth"])
        },
        data() {
            return {
            }
        },
        methods: {
            ...mapActions(["planningPreviousMonth", "planningCurrentMonth", "planningNextMonth"])
        }
    }

</script>

<style scoped>
</style>
